import { CustomFieldSpec, CustomFieldType } from "@nova/schemas"
import { v4 } from "uuid"

export interface FieldControls {
    editField: <T extends CustomFieldType>(id: string, spec: CustomFieldSpec<T>) => void
    deleteField: (id: string) => void
    moveField: (id: string, params: { direction: 1 | -1; skipAnimationFor?: string }) => void
    getNumFields: () => number
    registerCard: (id: string, node: HTMLElement | null) => void
}

export type FieldProps<T extends CustomFieldType = CustomFieldType> = {
    spec: CustomFieldSpec<T>
    fieldControls: FieldControls
    autoFocus?: boolean
}

export const emptyFieldSpec = <T extends CustomFieldType>(type: T): CustomFieldSpec<T> => {
    const emptySpecMap: Record<CustomFieldType, CustomFieldSpec> = {
        text: {
            id: v4(),
            type: "text",
            label: "",
        },
        "yes-no": {
            id: v4(),
            type: "yes-no",
            label: "",
        },
        "multiple-choice": {
            id: v4(),
            type: "multiple-choice",
            label: "",
            options: ["Option 1"],
        },
    }

    return emptySpecMap[type] as CustomFieldSpec<T>
}
